import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { observer } from 'mobx-react';
import SJHeader from '@product-framework/components/SJFormHandler/SJHeader';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Breadcrumb,
  LoadingEvent,
  SnackbarApiErrorMessage,
  useDataProvider,
  useLocalization,
  useSnackbar,
  useStore,
} from '@ui-framework/index';
import {
  IconLibrary,
  Layout,
  StackablePageButtons,
} from '@product-framework/index';
import Calendar from '../../components/DispatchCalendar/Calendar';

function ServiceJobDispatch() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const { id: pageId } = useParams();
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const [serviceJob, setServiceJob] = useState(null);
  const [loading, setLoading] = useState(null);

  const store = useStore();

  const breadCrumb = [
    {
      name: formatMessage({
        id: 'DASHBOARD_BREADCRUMB',
        defaultMessage: 'Dashboard',
      }),
      icon: IconLibrary.Dashboard,
      onClick: () => {
        navigate('/dashboard');
      },
    },
    {
      name: formatMessage({
        id: 'SERVICEJOBS_BREADCRUMB',
        defaultMessage: 'Jobs',
      }),
      permissionName: 'LIST_JOBS',
      icon: IconLibrary.ServiceJobs,
      onClick: () => {
        store.domain.list.reset('ServiceJobList');
        navigate('/servicejobs');
      },
    },
    {
      name: formatMessage({
        id: 'SERVICEJOB_BREADCRUMB',
        defaultMessage: 'Job',
      }),
      icon: IconLibrary.ServiceJob,
      onClick: undefined,
    },
  ];

  const stackablePageButtons = [];

  const fetchServiceJob = async () => {
    const url = `${getApiUrl()}/sxcl/v1/service-jobs/${pageId}`;
    const response = await get(url);
    if (response?.ok) {
      return response.data;
    }
    snackbar.showMessage({
      type: 'error',
      data: <SnackbarApiErrorMessage errors={response?.errors} />,
    });
    return null;
  };

  const initialize = async () => {
    setLoading(true);
    const data = await fetchServiceJob();
    setServiceJob(data);
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <Layout>
      <Grid2 container mb={1.5}>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      {!loading && (
        <Grid2>
          <SJHeader formData={serviceJob} sx={{ marginBottom: '10px' }} />
          <Calendar serviceJob={serviceJob} />
        </Grid2>
      )}
      {loading && <LoadingEvent>Fetching Job information</LoadingEvent>}
    </Layout>
  );
}

export default observer(ServiceJobDispatch);
